import { Image } from '@fluentui/react';
import React, { useMemo } from 'react';
import 'react-pdf/dist/esm/Page/AnnotationLayer.css';
import 'react-pdf/dist/esm/Page/TextLayer.css';

const PdfViewer = (props) => {

    const {
        fileData = undefined,
        extension = undefined,
        scale = 1
    } = props;

    const fileUrl = useMemo(
        () => `data:application/${extension};base64,${fileData}`,
        [extension, fileData]
    );

    const styles = useMemo(
        () => ({
            image: {
                image: { width: "100%" },
                root: {
                    padding: 10,
                    width: `${scale * 100}%`
                }
            },
        }), [scale]
    );

    return <Image src={fileUrl} styles={styles.image} />;

};

export default PdfViewer;